'use client';
import styles from './DownloadSegmented.module.scss';

const DownloadSegmented = ({ items, activeIndex, onClick }) => {
  const handleClick = (value) => {
    onClick?.(value);
  };

  return (
    <div className={styles.toggle}>
      <div className={styles.inner}>
        {items.map((item) => (
          <div
            key={item.index}
            role="presentation"
            className={styles.item}
            onClick={() => handleClick(item.index)}
            style={{ color: item.index === activeIndex ? '#121212' : '#828282' }}
          >
            {item.title}
          </div>
        ))}
        <div
          className={styles.slicer}
          style={{
            transform: `translateX(${activeIndex * 100}%)`,
            width: `${100 / items.length}%`,
          }}
        />
      </div>
    </div>
  );
};

export default DownloadSegmented;
